import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { KVideoState } from 'src/app/k-video/k-video.model';
import { PagesState } from 'src/app/pages/pages.model';

import { TrainingState } from '../training.model';
import { SetTaksIndex, DelTask, Pause, Play, PlayScene, Rec, SetSketches, SetCurrTime, StopRec, DoneRecording, ZoomIn, ZoomOut, UpdateProgress, DelTeacherVideo, SaveScene, Zoom, SetZoomOrPan } from '../training.actions';
import {
  currTime,
  goToAct,
  mimeExt,
  mimeType,
  otherRec,
  pause,
  play,
  playChanged,
  progress,
  rec,
  remoteZoomPan,

  sceneIndex,
  setSketch,
  sketchIndex,

  stopRec,
  taskIndex,
  zoom
} from '../training.selectors';
import { TrainingService } from '../training.service';
// import { streams } from 'src/app/k-video/k-video.selectors';
import { SVG } from '@svgdotjs/svg.js';
import { WSSState } from 'src/app/wss/wss.model';
import { callId, lastMsg } from 'src/app/wss/wss.selectors';
import { MS3Service } from '../m_s3.service';
import { KVideoService } from 'src/app/k-video/k-video.service';
import { NotifyError } from 'src/app/pages/pages.actions';
import { getQueryParameter } from 'src/app/utils';
import { streams } from 'src/app/k-video/k-video.selectors';
import { callerEmail } from 'src/app/pages/pages.selectors';


@Component({
  selector: 'care',
  templateUrl: './care.component.html',
  styleUrls: ['./overview/overview.component.scss', './care.component.scss']
})
export class CareComponent {

  my_play: any = {}
  task_index: number = -1;
  scene_index: number = -1;
  scene_start: number = 0
  task_zoom: any
  zoom_times: string[] = []

  public currentFacingMode: 'user' | 'environment' = 'user';
  camera_stream: MediaStream | undefined
  camera_video_width: number = 0
  camera_video_height: number = 0
  bShowSpinner: boolean = false
  mime_type: string = "video/webm"
  mime_ext: string = ".webm"
  task_key: string = "" //to create the rec key
  task_name: string = ""
  bAskForFile: boolean = false;

  roll: string = "parent" //for the rep
  bShowRecUI: boolean = true
  bTesting: boolean = false
  progress: number = 0  //End May 2025
  duration: number = 0
  start_rec_at: number = 0
  curr_time: number = 0
  scene_time: number = 0
  scene_name: string = "" //used by phone horizontal
  start_time: number = 0;
  end_time: number = -1
  scene_duration: number = 0



  bReadyToRecordTeacher: boolean = false
  bReadyToRecordTask: boolean = true
  rec_status: string = 'ready'

  recordedChunks: Blob[] = [] //used when we use the local file system

  @ViewChild('outComponent') outComponent: ElementRef | undefined
  @ViewChild('play_video') play_video1: ElementRef | undefined;// ==> video_elemen[this.act_key]
  @ViewChild('play_env_video') play_env_video: ElementRef | undefined;// ==> video_elemen[this.act_key]


  @ViewChild('canvas') canvas: ElementRef | undefined
  @ViewChild('teacherVideoElement') teacher_video: ElementRef | undefined;
  @ViewChild('recTeacher') teacher_rec: ElementRef | undefined;

  call_id: string | undefined
  patient_id: string | undefined//used to make the key
  mediaRecorder: MediaRecorder | undefined
  subscriptions: any[] = []

  act: string = "intro"

  isPhone: boolean = false
  isPhoneLS: boolean = false
  bShowOverview: boolean = true //used by the phone

  video_cont_w: number = 0 //used by mouse move
  video_cont_h: number = 0
  video_cont_l: number = 0
  video_cont_t: number = 0

  currTimeInterval: any
  draw_tool: any

  user_progress: any = {}
  files: any

  teacher_url: any //used to get the playback URL when we stop the recording
  task_s3_url: any

  bOtherRec: boolean = false

  colors: any = {
    intro: "#A9D6EB",
    describe: "#88D4AB",
    problems: "#F49899"
  }
  color: string = "#A9D6EB"
  bPlaying: boolean = false
  bReadyToZoomPanDraw: boolean = false


  rem_rec: any
  rem_facing: string = "user"
  remote_streams: any = {}
  remote_stream: MediaStream | undefined

  caller_email: string | undefined
  bRemoteBackExist: boolean = false
  constructor(
    public sanitizer: DomSanitizer,
    public trainingStore: Store<TrainingState>,
    public training_service: TrainingService,
    public pagesState: Store<PagesState>,
    public kVideoState: Store<KVideoState>,
    public wssState: Store<WSSState>,
    public canvasStore: Store<CanvasState>,
    public s3_service: MS3Service,
    public video_service: KVideoService ////Only for Caller

  ) {
    console.log("Care")
    this.bTesting = window.location.host.indexOf("localhost") >= 0
    if (!this.bTesting) {
      let betsy = getQueryParameter('betsy')
      if (betsy == "test") {
        this.bTesting = true
      }
    }
  }
  ngAfterViewInit() {
    //Navigation
    this.subscriptions.push(this.trainingStore.select(playChanged).subscribe((play: any) => {
      console.log("playChanged " + new Date())
      if (play && play._id) {
        this.patient_id = play._id
        setTimeout(() => {
          this.my_play = play
          this.setInScene(false, "playChanged")
        })
      }
    }))
    this.subscriptions.push(this.trainingStore.select(taskIndex).subscribe((index: number) => {
      if (this.task_index != index) {
        this.task_index = index
        this.setInScene(false, "taskIndex")
      }
    }))
    this.subscriptions.push(this.trainingStore.select(sceneIndex).subscribe((index: number) => {
      if (this.scene_index != index) {
        this.leavingScene()
        this.scene_index = index
        this.setInScene(false, "sceneIndex")
      }
    }))
    this.subscriptions.push(this.trainingStore.select(goToAct).subscribe(async (act: any) => {
      if (act && this.act != act) {
        this.leavingScene()
        setTimeout(() => {
          this.act = act;
          this.color = this.colors[act] + "33"
          setTimeout(() => {
            this.setInScene(false, "goToAct")
          })

        })
      }
    }))

    //User Roll Allways parent for the rep
    // this.subscriptions.push(this.pagesState.select(user).subscribe((user: any) => {
    //   if (user && user.customer_id) {
    //     this.roll = user.roll
    //     if (this.roll != 'care') {
    //       setTimeout(() => this.bShowRecUI = true)
    //     }
    //   }
    // }))
    this.subscriptions.push(this.wssState.select(callId).subscribe((call_id: string | undefined) => {
      this.call_id = call_id
      if (this.call_id) {
        this.roll = "parent"
        if (this.roll != 'clare') {
          setTimeout(() => this.bShowRecUI = true)
        }
      }
    }))
    this.subscriptions.push(this.trainingStore.select(progress).subscribe((progress: any) => {
      if (progress) {
        this.user_progress = progress
      }
    }))
    //remote streams
    this.subscriptions.push(this.kVideoState.select(streams).subscribe(async (streams: any) => {
      this.remote_streams = streams;
      //The first time the phone flips the screen, remote_back is not ready
      if (this.rem_facing == 'environment' && !this.bRemoteBackExist) {
        this.setRemoteStream()
      }


    }))
    this.subscriptions.push(this.pagesState.select(callerEmail).subscribe((email: string) => {
      this.caller_email = email
    }))
    //messages from rep
    this.subscriptions.push(this.wssState.select(lastMsg).subscribe((msg: any) => {

      if (msg && msg.k_t && msg.from) {
        if (msg.from == 'caller') {
          if (msg.k_t == "rem_rec") {
            this.rem_rec = msg
            if (this.rem_rec) {
              setTimeout(() => {
                this.rem_facing = msg.facing
                this.setRemoteStream()
              })
            }

          }
          if (this.rem_rec) {
            if (msg.k_t == "recording") {
              this.rec_status = 'recording'
              this.start_rec_at = new Date().getTime()
              //Start the interval to update the time
            } else if (msg.k_t == "stopped") {
              //We are done recording go back and start with the segments
              this.bAskForFile = false
              this.rem_rec = undefined
              this.bReadyToRecordTask = false
              this.start_rec_at = 0
              //we need to read it again
              if (this.patient_id) {
                this.training_service.getPatient(this.patient_id, this.caller_email)
              }
            } else if (msg.k_t == "rem_facing") {
              setTimeout(() => {
                this.rem_facing = msg.facing
                this.setRemoteStream()
              })
            }
          }
          return
        }

        if (msg.k_t == "stop") {
          if (msg.is_taks) {
            if (this.play_video1) {
              this.play_video1.nativeElement.currentTime = 0
              this.play_video1.nativeElement.pause()
              this.setPlaying(false)
              console.log("#CT to zero " + this.play_video1.nativeElement.currentTime)
            }
          } else {
            if (this.teacher_video) {
              this.teacher_video.nativeElement.currentTime = 0
              this.teacher_video.nativeElement.pause()
            }
          }
          this.trainingStore.dispatch(new DoneRecording(msg.duration, msg.is_taks, {
            url: msg.url,
            mime_ext: msg.mime_ext,
            width: msg.width,
            height: msg.height
          }))
        }
      }

    }))

    //zoom and pan
    this.subscriptions.push(this.trainingStore.select(zoom).subscribe(async (zoom: number) => {
      try {
        await this.setZoom(zoom)
        this.setZoomPanInPlayAndSendIt() //this will insert it in the play, and send it to the remote
      } catch (e: any) {

      }
    }))
    this.subscriptions.push(this.trainingStore.select(remoteZoomPan).subscribe((msg: any) => {
      this.setZoomPan(msg)
    }))


    //Recording

    this.subscriptions.push(this.trainingStore.select(mimeType).subscribe((mime_type: string) => {
      this.mime_type = mime_type;
    }))
    this.subscriptions.push(this.trainingStore.select(mimeExt).subscribe((mime_ext: string) => {
      this.mime_ext = mime_ext;
    }))
    this.subscriptions.push(this.trainingStore.select(otherRec).subscribe((count: number) => {
      this.bOtherRec = (count > 0)
      if (this.bOtherRec) {
        this.duration = 0
        this.start_rec_at = new Date().getTime()
        this.startPlay(true)
      }
    }))
    this.subscriptions.push(this.trainingStore.select(rec).subscribe((count: number) => {
      if (this.camera_stream && count) {
        if ((this.bReadyToRecordTask && this.play_video1) || (this.bReadyToRecordTeacher && this.teacher_video)) {
          console.log("recodrding  ")
          this.startRec()
        }
      }
    }))
    this.subscriptions.push(this.trainingStore.select(stopRec).subscribe((num: number) => {
      if (num) { this.stopRec() }
    }))


    //Playing
    this.subscriptions.push(this.trainingStore.select(currTime).subscribe((curr_time: number) => {
      setTimeout(() => {
        // this.curr_time = curr_time updated by the interval
        if (this.play_video1) {
          this.play_video1.nativeElement.currentTime = curr_time
          if (this.teacher_video) {
            let task_time = curr_time - this.scene_start
            this.teacher_video.nativeElement.currentTime = task_time
          }
        }
      })
    }))
    this.subscriptions.push(this.trainingStore.select(play).subscribe((num: number) => {
      if (num) {
        this.startPlay(false)
      }
    }))
    this.subscriptions.push(this.trainingStore.select(pause).subscribe((num: number) => {
      if (num) { this.pausePlay() }
    }))

    //Sketches
    this.subscriptions.push(this.trainingStore.select(sketchIndex).subscribe((index: number) => {
      this.changeSketch(index)
    }))

    this.subscriptions.push(this.trainingStore.select(setSketch).subscribe((last_sketch: any) => {
      if (last_sketch) {
        let sarray = last_sketch.array.replace(/\s+/g, ' ').trim();
        let array: number[] = last_sketch.array
        if (last_sketch.width != this.video_cont_w || last_sketch.height != this.video_cont_h) {
          array = []
          let sa = sarray.split(' ')
          for (let i = 0; i < sa.length; i += 2) {
            let x = parseFloat(sa[i])
            let y = parseFloat(sa[i + 1])
            let x1 = x * this.video_cont_w / last_sketch.width
            let y1 = y * this.video_cont_h / last_sketch.height
            array.push(x1)
            array.push(y1)
          }

        }
        let poly = this.draw_tool.polyline(array).fill('none').stroke({ width: 5, color: last_sketch.stroke, linecap: 'round' })
        this.sketches.push({
          line: poly,
          time: last_sketch.time,
        })
      }
    }))

    //Interval
    // let progress_debounce: number = 0
    // let bAddedLoadMeta: boolean = true

    this.currTimeInterval = setInterval(() => {
      if (this.play_video1) {
        if ((this.bReadyToRecordTask || this.rec_status == 'recording') && this.start_rec_at) {
          this.duration = Math.round((new Date().getTime() - this.start_rec_at) / 1000)
        } else {
          //This is to set the time when the file was selected or uploaded
          if (this.duration) {
            let curr_time = this.play_video1.nativeElement.currentTime
            if (this.curr_time != curr_time) {

              this.checkZoomPan(curr_time)


              setTimeout(() => {
                this.curr_time = curr_time
                this.scene_time = curr_time - this.scene_start
                this.progress = this.scene_time / this.scene_duration * 100


                if (!this.bReadyToRecordTask && !this.bReadyToRecordTeacher && this.end_time > 0 && this.end_time && this.curr_time > this.end_time) {
                  if (this.play_video1) {  // this.pause()
                    this.play_video1.nativeElement.currentTime = 0.02;
                    this.play_video1.nativeElement.load()
                    this.play_video1.nativeElement.pause()
                    this.setPlaying(false)
                    this.scene_time = 0
                    this.progress = 0
                  }
                  // let now = new Date().getTime()
                  // let dif = now - progress_debounce
                  // if (dif > 1000) {
                  //   this.updateProgress()
                  //   progress_debounce = now
                  // }
                }
              })
            }
          }

        }
      }
    }, 100)
  }

  async setRemoteStream() {
    let remote_stream
    if (this.remote_streams) {
      if (this.rem_facing == 'user') { //whoe the caller stream
        remote_stream = this.remote_streams["caller"]
      } else {
        if (this.remote_streams["remote_back"]) {
          remote_stream = this.remote_streams["remote_back"]
          this.bRemoteBackExist = true
        } else {
          this.bRemoteBackExist = false
        }
      }
      if (remote_stream) {
        let video_tracks = remote_stream.getVideoTracks()
        console.log("#CASU Num of remote_stream " + this.rem_facing + " video tracks (setRemoteStream) " + video_tracks.length)
        if (video_tracks.length > 0) {
          let sel_track = video_tracks[0]

          //Now create a stream with the sel_track
          let bTrackExist: boolean = false
          if (this.remote_stream) {
            let tracks = this.remote_stream.getVideoTracks()
            if (tracks.length == 1) {
              let curr_track = tracks[0]
              bTrackExist = (curr_track.id == sel_track.id)
            }
          }
          if (bTrackExist == false) {
            this.remote_stream = new MediaStream()
            this.remote_stream.addTrack(sel_track)
          }

          //now add the audio tracks
          if (this.remote_stream) {
            let audio_tracks = remote_stream.getAudioTracks()
            let num_audio_tracks = audio_tracks.length
            if (num_audio_tracks > 0) {
              let prev_audio_tracks = this.remote_stream.getAudioTracks()
              if (prev_audio_tracks.length == 1) {
                let curr_track = prev_audio_tracks[0]
                bTrackExist = (curr_track.id == sel_track.id)
              }
              if (!bTrackExist) {
                for (let i = 0; i < num_audio_tracks; i++) {
                  let audio_track = audio_tracks[i]
                  this.remote_stream.addTrack(audio_track)
                }
              }
            } else {
              console.error("We did not get audio tracks in remote stream")
            }
          }

          if (this.play_video1) {
            if (this.play_video1.nativeElement.srcObject && this.remote_stream) {
              if (this.play_video1.nativeElement.srcObject.id == this.remote_stream.id) {
                return
              }
            }
            let dims = await this.findFileOrStreamDim(this.remote_stream)
            this.setTaskVideoStream(dims)
            this.rec_status = 'ready'
          }
        }
      } else {
        console.error("remote_back not ready")
      }
    }
  }
  setPlaying(bPlaying: boolean) {
    let bReadyToZoomPanDraw: boolean = false
    if (this.roll == 'parent' && !bPlaying) {
      if (this.act == 'intro') {
        bReadyToZoomPanDraw = !this.bReadyToRecordTask
      } else {
        bReadyToZoomPanDraw = !this.bReadyToRecordTeacher
      }
    }
    setTimeout(() => {
      this.bPlaying = bPlaying
      this.bReadyToZoomPanDraw = bReadyToZoomPanDraw
    })
  }
  prev_zoom_pan_at: string = ""
  checkZoomPan(curr_time: number) {
    if (this.task_zoom) {
      let what
      let index = 0
      let at = this.zoom_times[index]
      if (curr_time >= parseFloat(at)) {
        while (index + 1 < this.zoom_times.length) {
          index++
          let next = this.zoom_times[index]
          if (parseFloat(next) > curr_time) {
            break;
          } else {
            at = next
          }
        }
        if (this.prev_zoom_pan_at != at) {
          what = this.task_zoom[at]
        }
      }
      if (what) {
        if (this.setZoomPan(what)) {
          this.prev_zoom_pan_at = at
        }
      }
    }
  }
  ngOnDestroy(): void {
    this.leavingScene()
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
    if (this.currTimeInterval) {
      clearInterval(this.currTimeInterval)
    }
    this.removeCanvas()
  }
  prev_task_index: number = -1
  prev_scene_index: number = -1
  previous_LS: boolean = false
  previous_act: string = ""
  previous_task_movie_name = ""
  getCurrentTaskAndScene() {
    let scene: any
    let task: any

    if (this.my_play && this.my_play.tasks && this.task_index >= 0) {
      task = this.my_play.tasks[this.task_index]
      if (task && task.scenes && this.scene_index >= 0) {
        this.task_key = task.task_key
        this.task_name = task.name
        scene = task.scenes[this.scene_index]

      }
    }
    return { scene: scene, task: task }
  }
  delStepVideo() {
    let rv = this.getCurrentTaskAndScene()
    this.training_service.delStepVideoFromS3(rv.task, rv.scene, this.act)
    this.trainingStore.dispatch(new DelTeacherVideo(this.scene_index, this.act))
  }
  //****************************************************************************
  // Set the scene
  //****************************************************************************

  async setInScene(bUserSelectedCamera: boolean, from: string) {
    let rv = this.getCurrentTaskAndScene()
    let scene: any = rv.scene
    let task: any = rv.task

    if (scene && scene.name) {
      console.log("#Set Scene from " + from + " " + new Date().getTime())

      if (!scene.movie_name) {
        if (this.roll != "care") {
          if (!this.isPhone && !bUserSelectedCamera) {
            this.bAskForFile = true
          }
          if (bUserSelectedCamera || (
            this.play_video1 &&
            !this.camera_stream   //Avoid redoing it when there is no real change
            || this.task_index != this.prev_task_index
            || this.scene_index != this.prev_scene_index
            || this.act != this.previous_act
            || this.isPhoneLS != this.previous_LS)
          ) {
            try {
              this.prev_task_index = this.task_index
              this.prev_scene_index = this.scene_index
              this.previous_act = this.act
              this.previous_LS = this.isPhoneLS

              console.log("#Set Scene TI " + this.task_index + " SI " + this.scene_index + " LS " + this.isPhoneLS)
              let dic = await this.getCameraSrtreamAndDim()
              if (dic && this.play_video1) {
                this.setTaskVideoAndDim(dic)
              }

            } catch (e) {
              console.error(e)
            }
            this.scene_start = scene.start

          }
        } else {
          this.pagesState.dispatch(new NotifyError("User not authorize to record"))
        }
      } else { //The scene has a movie
        this.bAskForFile = false
        if (this.previous_task_movie_name != scene.movie_name) {
          this.previous_task_movie_name = scene.movie_name
          if (this.my_play && this.my_play.tasks) {
            let task = this.my_play.tasks[this.task_index]
            if (task.play_movies) {
              let dic = task.play_movies[scene.movie_name]
              setTimeout(() => {//give it a chance to load
                if (dic && this.play_video1) {
                  this.setTaskVideoAndDim(dic)
                  this.setPlaying(false)
                }
              })
            }
          }
        }
        if (scene.hasOwnProperty("start")) {
          this.start_time = scene.start

          if (this.play_video1) {
            if (this.task_index != this.prev_task_index
              || this.scene_index != this.prev_scene_index
            ) {
              this.prev_task_index = this.task_index
              this.prev_scene_index = this.scene_index
              this.play_video1.nativeElement.currentTime = scene.start
              // this.loadTaskSketches() is the same for all the scenes, so its done by setCanvas for each task
            }
          }
        } if (this.act) {
          if (this.act == 'intro') {
            this.bReadyToRecordTeacher = false
          } else {

            let movie
            if (scene[this.act]) {
              let movie_name = scene[this.act].movie_name
              movie = task.play_movies[movie_name]
            }
            if (movie) {
              this.setTeacherMovie(movie)
            } else {
              this.teacher_url = undefined
              //Get the Video Feed to the teacher
              let dic = await this.getCameraSrtreamAndDim() //It should be the small one

              if (dic && this.teacher_rec) {
                this.setTeacherRec(dic)
                this.bReadyToRecordTeacher = true
              }
            }

          }
        }
        setTimeout(() => {
          if (scene.end) {
            this.end_time = scene.end
            this.scene_start = scene.start
            this.scene_name = scene.name
          }
          this.scene_duration = scene.end - scene.start
        })
        if (task.zoom_pan) {
          let act = 'intro' //this.act change also in training.reducer to support independent zoom and pan
          this.task_zoom = task.zoom_pan[act]
          if (this.task_zoom) {
            this.zoom_times = Object.keys(this.task_zoom).sort();
            this.checkZoomPan(scene.start)
          }
        }
      }
      this.setPlaying(false)
    }
  }
  setTeacherRec(dic: any) {
    if (this.teacher_rec) {
      if (dic.stream) {
        if (dic.stream instanceof MediaStream && dic.stream.active) {
          if (!this.teacher_rec.nativeElement.srcObject || this.teacher_rec.nativeElement.srcObject.id != dic.stream.id) {
            try {
              this.teacher_rec.nativeElement.srcObject = dic.stream
              this.teacher_rec.nativeElement.play()
              this.teacher_rec.nativeElement.muted = true
              this.teacher_rec.nativeElement.volume = 0.0
              this.bReadyToRecordTeacher = true
            } catch (error) {
              console.error("Error setting srcObject:", error);
            }
          }
          else {
            console.log("#VP same stream")
          }
        }
      }
    }
  }
  //New Scene options
  startVideoTask() {
    try {
      this.bAskForFile = false;
      // this.bShowVideoTask = true
      setTimeout(async () => {
        console.log("#RT @SV startVideoTaskt")
        this.setInScene(true, "user start") //user selected to use camera
      }, 100)
    } catch (e) {

    }

  }

  //Sketches
  loadTaskSketches() {
    let rv = this.getCurrentTaskAndScene()
    let task: any = rv.task
    if (this.draw_tool && task && task.sketches) {

      let polylines = this.draw_tool.find('polyline')
      for (let i = 0; i < polylines.length; i++) {
        let polyline = polylines[i]
        polyline.remove()
      }


      this.sketches = []
      let my_sketches = task.sketches
      if (this.draw_tool && my_sketches) {
        for (let i = 0; i < my_sketches.length; i++) {
          let sketch: any = my_sketches[i]
          let stroke = sketch.stroke + '00'
          if (!stroke) {
            stroke = '#8F5CFF00'
          }
          //normalize the array
          let sarray = sketch.array.replace(/\s+/g, ' ').trim();
          let array: number[] = sketch.array
          if (sketch.width != this.video_cont_w || sketch.height != this.video_cont_h) {
            array = []
            let sa = sarray.split(' ')
            for (let i = 0; i < sa.length; i += 2) {
              let x = parseFloat(sa[i])
              let y = parseFloat(sa[i + 1])
              let x1 = x * this.video_cont_w / sketch.width
              let y1 = y * this.video_cont_h / sketch.height
              array.push(x1)
              array.push(y1)
            }

          }

          let poly = this.draw_tool.polyline(array).fill('none').stroke({ width: 5, color: stroke, linecap: 'round' })
          this.sketches.push({
            line: poly,
            time: sketch.time,
            width: this.video_cont_w,
            height: this.video_cont_h
          })
        }
      }
    }
  }
  changeSketch($event: any) {
    if (this.play_video1) {
      this.sketch_index = $event
      let sketch = this.sketches[this.sketch_index]
      if (sketch) {
        this.sketch_time = sketch.time
        for (let i = 0; i < this.sketches.length; i++) {
          let sketch = this.sketches[i]
          let ncolor = sketch.line.node.getAttribute('stroke').substring(0, 7)
          if (i == $event) {
            ncolor += "FF"
            this.play_video1.nativeElement.currentTime = sketch.time
            this.play_video1.nativeElement.pause()
            this.setPlaying(false)
            if (this.teacher_video) {
              this.teacher_video.nativeElement.currentTime = sketch.time
              this.teacher_video.nativeElement.pause()
            }
          } else {
            ncolor += "00"
          }
          sketch.line.node.setAttribute('stroke', ncolor);
        }
        this.training_service.changeSketch($event)
      }
    }
  }


  leavingScene() { //when the scene_index changes
    if (this.scene_index >= 0) { //when the scene_index changes
      this.trainingStore.dispatch(new SaveScene())
    }
  }
  updateScketches() {

    if (this.sketches.length > 0) {
      let s_sketchs = []
      for (let i = 0; i < this.sketches.length; i++) {
        let sketch = this.sketches[i]
        // let attr = sketch.line.attr()
        let stroke = sketch.line.node.getAttribute('stroke')
        let points = sketch.line.node.getAttribute('points')

        s_sketchs.push({
          time: sketch.time,
          stroke: stroke,
          array: points,
          width: sketch.width,
          height: sketch.height
        })
      }
      this.trainingStore.dispatch(new SetSketches(s_sketchs, this.scene_index))
      // this.sketches = [], we only load them in the task, don't delete them

    }

    // this.trainingStore.dispatch(new SaveToFileAndGo(action))
  }

  seekBar($event: any) {
    //This is for the scene
    let perc = $event.layerX / $event.currentTarget.clientWidth
    let duration = this.end_time - this.start_time
    let scene_time = perc * duration
    let new_time = this.start_time + scene_time
    this.trainingStore.dispatch(new SetCurrTime(new_time))
    this.seek(new_time)
    console.log("Seek bar to " + new_time)

  }
  seekSeg(time: number) { //Its the time of the play video not the scene
    if (this.play_video1) {
      this.trainingStore.dispatch(new SetCurrTime(time))
      this.play_video1.nativeElement.currentTime = time
      this.play_video1.nativeElement.load()
      this.play_video1.nativeElement.pause()
      this.setPlaying(false)
      // this.curr_time = time This is done by the interval handler
      console.log("Seek seg to " + time)
      this.training_service.currTime(time)
    }
  }

  seek(time: number) {
    let task_time = time + this.start_time
    if (this.play_video1 && task_time < 2) {
      setTimeout(() => {

        if (this.play_video1) {
          let delay = (task_time + 0.02) * 1000
          this.play_video1.nativeElement.currentTime = 0.02;
          this.play_video1.nativeElement.load()
          this.play_video1.nativeElement.pause()
          this.startPlay(false)
          this.play_video1.nativeElement.muted = true;
          this.play_video1.nativeElement.volume = 0.0;

          let interval = setInterval(() => {
            if (this.play_video1) {
              if (this.play_video1.nativeElement.currentTime >= task_time) {
                this.play_video1.nativeElement.pause()
                if (this.teacher_video) {
                  this.teacher_video.nativeElement.pause()
                }
                console.log("task time " + task_time + " video time " + this.play_video1.nativeElement.currentTime)
                clearInterval(interval)
              }
            }
          }, 10)
        }
      })
    } else {
      if (this.play_video1) {
        this.play_video1.nativeElement.currentTime = task_time
        this.play_video1.nativeElement.load()
        this.play_video1.nativeElement.pause()
        this.setPlaying(false)
      }
      if (this.teacher_video) {
        this.teacher_video.nativeElement.currentTime = time
        this.teacher_video.nativeElement.load()
        this.teacher_video.nativeElement.pause()
      }
    }
  }

  //****************************************************************************
  // Camera selection
  //****************************************************************************
  async switchCamera(flips: boolean): Promise<void> {
    if (flips) {
      this.currentFacingMode = this.currentFacingMode === 'user' ? 'environment' : 'user';
    }
    this.getVideoCameraStream()
  }
  last_video_stream_act: string = ""
  async getVideoCameraStream(): Promise<any> {
    return new Promise<MediaStream>(async (resolve, reject) => {
      //avoid discoecting the same stream
      if (this.camera_stream && this.camera_stream.active && this.last_video_stream_act == this.act) {
        console.log("Use the same stream for " + this.act)
        resolve(this.camera_stream)
        return
      }

      let constrains
      if (this.act == 'intro') {
        constrains = {
          facingMode: this.currentFacingMode,
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      } else {
        constrains = {
          facingMode: this.currentFacingMode,
          width: { ideal: 640 },
          height: { ideal: 480 }
        }
      }
      let stream: MediaStream | undefined

      try {

        if (this.camera_stream) {
          this.camera_stream.getTracks().forEach((track: MediaStreamTrack) => {
            track.stop()
            console.log("#VP getVideoCameraStream stopped " + track.kind)
          });
        }

        console.log("#VP getVideoCameraStream " + JSON.stringify(constrains))
        stream = await navigator.mediaDevices.getUserMedia({
          video: constrains,
          audio: true
        });
        if (stream) {
          if (stream.active) {//}&& !this.isPhone) {
            // stream.getTracks().forEach((track: MediaStreamTrack) => {
            //   console.log("#VP getVideoCameraStream " + track.kind)
            // })
            this.last_video_stream_act = this.act
            resolve(stream)
          } else {
            reject("Inactive stream")
          }
        } else {
          reject("no stream")
        }
      } catch (error) {
        console.error('Error accessing camera:', error);
        reject()
      }
    })
  }



  //****************************************************************************
  // Play
  //****************************************************************************
  play() {
    this.trainingStore.dispatch(new Play())
    this.training_service.play()
  }
  stop() {
    if (this.call_id) {
      this.training_service.stopOther()
    } else {

      this.trainingStore.dispatch(new StopRec())

      // if (this.bOtherRec) {
      //   this.training_service.stopOther()
      // }

    }
  }
  pause(): void {
    this.trainingStore.dispatch(new Pause())
    this.training_service.pause()
  }

  startPlay(bRecording: boolean) { //true when we are recording
    if (this.play_video1) {
      this.bPanning = true
      if (this.play_video1.nativeElement.src || this.play_video1.nativeElement.srcObject) {
        this.play_video1.nativeElement.addEventListener("ended", () => {
          console.log("Video has finished playing!");
          this.progress = 100
        });
        this.setPlaying(true)
        if (bRecording) {
          this.play_video1.nativeElement.muted = true;
          this.play_video1.nativeElement.volume = 0.0;
          if (this.teacher_video) {
            this.teacher_video.nativeElement.muted = true;
            this.teacher_video.nativeElement.volume = 0.0;
          }
        } else { //Playback
          if (this.act == 'intro') {

            this.play_video1.nativeElement.muted = false;
            this.play_video1.nativeElement.volume = 1.0;
            if (this.teacher_video) {
              this.teacher_video.nativeElement.muted = true;
              this.teacher_video.nativeElement.volume = 0.0;
            }
          } else {
            this.play_video1.nativeElement.muted = true;
            this.play_video1.nativeElement.volume = 0.0;
            if (this.teacher_video) {
              this.teacher_video.nativeElement.muted = false;
              this.teacher_video.nativeElement.volume = 1.0;
            }
          }
        }
      }
      this.play_video1.nativeElement.play()
    }
    if (this.teacher_video && !this.bReadyToRecordTeacher) {
      if (this.teacher_video.nativeElement.src || this.teacher_video.nativeElement.srcObject) {
        this.teacher_video.nativeElement.play()
      }
    }
  }
  pausePlay() {
    if (this.play_video1) {
      this.play_video1.nativeElement.pause()
      this.setPlaying(false)
    }
    if (this.teacher_video) {
      this.teacher_video.nativeElement.pause()
    }
  }

  //****************************************************************************
  // Zoom and Pan
  //****************************************************************************
  setZoomPan(msg: any) {
    if (this.video_cont_w && this.video_cont_h && msg) {
      this.video_l = msg.video_l / msg.video_cont_w * this.video_cont_w
      this.video_t = msg.video_t / msg.video_cont_h * this.video_cont_h
      this.video_w = msg.video_w / msg.video_cont_w * this.video_cont_w
      this.video_h = msg.video_h / msg.video_cont_h * this.video_cont_h
      this.zoom = msg.video_w / msg.video_cont_w
      this.trainingStore.dispatch(new Zoom(this.zoom))
      return true
      //     this.verifyZoomPan()
    }
    return false
  }
  setZoomPanInPlayAndSendIt() { //set the state of the screen in the play and send it to the other side
    if (this.video_cont_w && this.video_cont_h) {
      let msg = {
        k_t: "remote_zoom_pan",
        video_l: this.video_l,
        video_t: this.video_t,
        video_w: this.video_w,
        video_h: this.video_h,
        video_cont_w: this.video_cont_w,
        video_cont_h: this.video_cont_h,
        time: this.curr_time
      }
      this.trainingStore.dispatch(new SetZoomOrPan(msg))
      this.training_service.sendZoomPan(msg)
    }
  }
  setZoom(zoom: number) {
    return new Promise<boolean>(async (resolve, reject) => {

      if (this.zoom != zoom) {
        this.zoom = zoom

        setTimeout(() => {
          let prev_w = this.video_w
          let prev_h = this.video_h
          this.video_w = this.video_cont_w * zoom
          this.video_h = this.video_cont_h * zoom
          let delta_w = this.video_w - prev_w
          let delta_h = this.video_h - prev_h
          this.video_l -= (delta_w / 2)
          this.video_t -= (delta_h / 2)
          resolve(true)
        })
      } else {
        reject()
      }
    })
  }

  verifyZoomPan() {
    if (this.video_l + this.video_w < this.video_cont_w) {
      this.video_l = this.video_cont_w - this.video_w
    }
    if (this.video_l > 0) {
      this.video_l = 0

    }
    if (this.video_t + this.video_h < this.video_cont_h) {
      this.video_t = this.video_cont_h - this.video_h
    }
    if (this.video_t > 0) {
      this.video_t = 0
    }

  }

  //May 17, 25 on zoom in zoom out send the notification to the server

  zoomIn() {
    this.trainingStore.dispatch(new ZoomIn(this.video_cont_w, this.video_cont_h))
  }
  zoomOut() {
    if (this.zoom > 1) {
      this.trainingStore.dispatch(new ZoomOut(this.video_cont_w, this.video_cont_h))
    }
  }

  draw() {
    this.bPanning = !this.bPanning
  }
  //****************************************************************************
  // Rremote recording, this messages are handled by care.component in the caller
  //****************************************************************************
  recRemTask() {
    this.training_service.recRemTask() // caller for caller

  }
  stopRemTask() {
    this.training_service.stopRemTask() // caller for caller

  }
  flipRemTask() {
    this.training_service.flipRemTask() // caller for caller
  }


  //****************************************************************************
  // Record
  //****************************************************************************

  async  rec() {
    if (this.call_id) {
      this.training_service.rec("caller") // caller for caller
    } else {
      this.trainingStore.dispatch(new Rec()) //caller for caller
    }
  }
  s3_rec_key: string = ""
  async stopRec() {
    if (this.bOtherRec) {
      this.bOtherRec = false
      return
    }
    if (this.rec_status == "recording") {

      this.bShowSpinner = true
      this.rec_status = "stopping"
      if (this.mediaRecorder) {
        if (this.act == 'intro') {
          this.task_s3_url = await this.training_service.getVideoTrainingUrl(this.s3_rec_key)
        } else {
          this.teacher_url = await this.training_service.getVideoTrainingUrl(this.s3_rec_key)
        }
        this.mediaRecorder.stop();
      }
    }
  }
  async startRec() {
    let rec_stream
    if (this.bReadyToRecordTask) {
      if (this.play_video1) {

        rec_stream = this.play_video1.nativeElement.srcObject
        this.duration = 0
        this.start_rec_at = new Date().getTime()
      } else {
        return
      }
    } else {
      if (this.teacher_rec) {
        rec_stream = this.teacher_rec.nativeElement.srcObject
        this.bReadyToRecordTeacher = true;
        this.startPlay(true) //play the background image while we record
      } else {
        return
      }
    }
    if (rec_stream) {
      let recS3Url: any

      if (this.act == 'intro') {
        this.s3_rec_key = this.patient_id + "/" + this.task_key + "/task" + this.mime_ext
      } else {
        this.s3_rec_key = this.patient_id + "/" + this.task_key + "/" + this.act + "_" + this.scene_index + this.mime_ext
      }
      try {
        let url: string = await this.s3_service.getRecToS3URL(this.s3_rec_key, this.mime_type)
        if (url) {
          console.log("url " + url)
          recS3Url = url// July 7,25 don't decode it decodeURIComponent(url);
          console.log("recS3Url " + recS3Url)
        }
      } catch (e) {
        console.error(e)
        return
      }


      this.rec_status = 'recording'
      this.mediaRecorder = new MediaRecorder(rec_stream, { mimeType: this.mime_type });
      this.recordedChunks = []

      let me = this
      this.mediaRecorder.ondataavailable = async function(event: any) {
        console.log("MP# data-available " + event.data.size + " " + new Date().getTime());
        if (event.data.size > 0) {
          let blob: Blob = event.data
          if (recS3Url) {
            me.start_rec_at = 0
            try {
              await me.s3_service.uploadChunk(recS3Url, blob, me.mime_type)
              if (me.act == 'intro') {
                console.log("play task video " + me.task_s3_url.url)
                me.trainingStore.dispatch(new DoneRecording(me.duration, true, {
                  url: me.task_s3_url,
                  mime_ext: me.mime_ext,
                  width: me.camera_video_width,
                  height: me.camera_video_height
                }))
                me.training_service.stop(me.task_s3_url, true, me.duration, me.mime_ext, me.camera_video_width, me.camera_video_height)
                me.rec_status = "ready"
                me.bShowSpinner = false
              } else if (me.teacher_url) {
                me.trainingStore.dispatch(new DoneRecording(me.duration, false, {
                  url: me.teacher_url,
                  mime_ext: me.mime_ext,
                  width: me.camera_video_width,
                  height: me.camera_video_height
                }))
                me.training_service.stop(me.teacher_url, false, me.duration, me.mime_ext, me.camera_video_width, me.camera_video_height)
                me.rec_status = "ready"
                me.bShowSpinner = false
              }
              me.bReadyToRecordTask = false
              setTimeout(async () => {
                me.pausePlay()
              })
            } catch (e) {
              me.bShowSpinner = false
              me.pagesState.dispatch(new NotifyError("Error uploading file"))
              console.error(e)
            }
          } else {
            me.recordedChunks.push(blob)
          }
        } else {
          console.log("MP# event.data.size <= 0 ");
        }
      }
      this.mediaRecorder.onstop = async () => {
        if (this.play_video1) {
          this.play_video1.nativeElement.pause()
          this.setPlaying(false)
          this.play_video1.nativeElement.currentTime = 0
        }
      }
      this.start_rec_at = new Date().getTime()
      this.mediaRecorder.start(); //We did not specify timeslice, so ondataavailable will trigger at the end
      //If we want to do very long movies we need to change this

    }
  }


  //**************************************************************************
  // Drawing
  //**************************************************************************
  local_drawing_poly: any | undefined
  local_poly_array: number[] = []
  sketches: any[] = []
  sketch_index: number = 0 //used by the editor
  sketch_time: number = 0
  last_sketch_at: number = 0
  fadeInterval: any

  video_w: number = 640
  video_h: number = 480
  video_l: number = 0
  video_t: number = 0

  bPanning: boolean = true //On off by the icon
  bPointPanningMouseDown: boolean = false
  bTouchPanningMouseDown: boolean = false
  pointer_id: number = -1 //to capture the mouse

  zoom: number = 1
  orig_x: number = 0
  orig_y: number = 0
  orig_l: number = 0
  orig_t: number = 0

  setCanvas(video_w: number, video_h: number) {
    if (this.canvas && this.canvas.nativeElement.children.length == 0) {
      this.draw_tool = SVG().addTo(this.canvas.nativeElement)
      let childern = this.canvas.nativeElement.children
      if (childern) {
        let svg_node = childern[0]
        if (svg_node) {
          svg_node.setAttribute("viewBox", "0 0 " + video_w + " " + video_h);
        }
      }
      this.canvas.nativeElement.addEventListener('pointerdown', this.onMouseDown);
      this.canvas.nativeElement.addEventListener('touchstart', this.onMouseDown);
      this.canvas.nativeElement.addEventListener('pointermove', this.onMouseMove);
      this.canvas.nativeElement.addEventListener('touchmove', this.onMouseMove);
      this.canvas.nativeElement.addEventListener('pointerup', this.onMouseUp);
      this.canvas.nativeElement.addEventListener('touchend', this.onMouseUp);
      const fade_in = 5 //in secs
      let fade_in_delta = 255 / fade_in
      this.loadTaskSketches() //If failed because draw_tool was undefined
      this.fadeInterval = setInterval(() => {

        for (let i = 0; i < this.sketches.length; i++) {
          let sketch = this.sketches[i]
          //Get the intencity for the src
          if (this.play_video1 && this.play_video1.nativeElement.paused == false) {
            let secs = this.play_video1.nativeElement.currentTime - sketch.time
            let ncolor = sketch.line.node.getAttribute('stroke').substring(0, 7)

            if (secs <= 0) {
              ncolor += "00"
            } else {
              let intencity = 255 - Math.floor(fade_in_delta * secs)
              ncolor += intencity.toString(16);
            }
            sketch.line.node.setAttribute('stroke', ncolor);
          }
        }
        // }
      }, 100)
    }
  }

  removeCanvas() {
    if (this.outComponent) {
      this.outComponent.nativeElement.removeEventListener('keydown', this.onMouseDown)
      this.outComponent.nativeElement.removeEventListener('touchstart', this.onMouseDown);
      this.outComponent.nativeElement.removeEventListener('pointermove', this.onMouseMove);
      this.outComponent.nativeElement.removeEventListener('touchmove', this.onMouseMove);
      this.outComponent.nativeElement.removeEventListener('pointerup', this.onMouseUp);
      this.outComponent.nativeElement.removeEventListener('touchend', this.onMouseUp);
    }
    if (this.fadeInterval) {
      clearInterval(this.fadeInterval)
    }
    if (this.currTimeInterval) {
      clearInterval(this.currTimeInterval)
    }
  }

  delSketch() {
    let sketch = this.sketches[this.sketch_index]
    sketch.line.remove()
    this.sketches.splice(this.sketch_index, 1);
    if (this.sketch_index > this.sketches.length - 1) {
      this.sketch_index--
    }
    if (this.sketch_index < 0) {
      this.sketch_index = 0
    }

    this.changeSketch(this.sketch_index)
    this.training_service.delSketch(this.sketch_index)
  }
  //**************************************************************************
  // Mouse Down
  //**************************************************************************
  orig_distance: number = 0
  orig_zoom: number = 1
  onMouseDown = ($event: any) => {
    $event.preventDefault()
    if (this.bPanning && this.canvas) {
      this.pointer_id = $event.pointerId
      if (this.pointer_id > 0) {
        this.canvas.nativeElement.setPointerCapture(this.pointer_id)
      }
      if (!this.isPhone && $event instanceof PointerEvent) {
        this.orig_l = this.video_l
        this.orig_t = this.video_t
        this.orig_x = $event.offsetX
        this.orig_y = $event.offsetY
        console.log("Pan D pointer orig= " + this.orig_x + ", " + this.orig_y + " video_l= " + this.video_l + " t=" + this.video_t)
        this.bPointPanningMouseDown = true
      } else if ($event instanceof TouchEvent && $event.touches && $event.touches.length > 0) {
        this.orig_l = this.video_l
        this.orig_t = this.video_t
        const touch = $event.touches[0]; // First touch point
        this.orig_x = touch.pageX
        this.orig_y = touch.pageX
        console.log("Pan D touch orig= " + this.orig_x + ", " + this.orig_y + " video_l= " + this.video_l + " t=" + this.video_t)
        this.bTouchPanningMouseDown = true
        this.bPointPanningMouseDown = false //We only use one
        if ($event.touches && $event.touches.length === 2) {
          this.orig_distance = this.getDistance($event.touches[0], $event.touches[1]);
          this.orig_zoom = this.zoom
          console.log("Zoom D distance " + this.orig_distance + " orig_zoom " + this.orig_zoom)
        }
      }
    } else {
      if (this.bReadyToRecordTeacher) { return }
      console.log("local mouse down " + $event.offsetX + ", " + $event.offsetY)
      if (!this.local_drawing_poly && this.draw_tool) {
        this.local_poly_array = [$event.offsetX, $event.offsetY]
        this.local_drawing_poly = this.draw_tool.polyline(this.local_poly_array).fill('none').stroke({ width: 5, color: '#FFBA55', linecap: 'round' })

      }
    }
  }
  getDistance(touch1: any, touch2: any) {
    const dx = touch1.pageX - touch2.pageX;
    const dy = touch1.pageY - touch2.pageY;
    return Math.hypot(dx, dy);
  }

  //**************************************************************************
  // Mouse Move
  //**************************************************************************
  onMouseMove = ($event: any) => {
    $event.preventDefault()
    if ($event instanceof PointerEvent) {
      console.log("Pan onMouseMove PointerEvent")
    }
    if ($event instanceof TouchEvent) {
      console.log("Pan onMouseMove TouchEvent " + $event.touches.length + " touches ")
    }
    if (this.bPanning) {
      if (this.bPointPanningMouseDown) {
        if ($event instanceof PointerEvent) {
          let dx = $event.offsetX - this.orig_x
          let dy = $event.offsetY - this.orig_y
          this.video_l = this.orig_l + dx
          this.video_t = this.orig_t + dy
          this.verifyZoomPan()
          console.log("Pan M point orig=" + this.orig_x + ", " + this.orig_y + " video_l= " + this.video_l + " t=" + this.video_t + " delta " + dx + ", " + dy)
        }
      } else if (this.bTouchPanningMouseDown) {
        if ($event instanceof TouchEvent && $event.touches && $event.touches.length > 0) {

          const touch = $event.touches[0]; // First touch point
          let dx = touch.pageX - this.orig_x
          let dy = touch.pageY - this.orig_y
          this.video_l = this.orig_l + dx
          this.video_t = this.orig_t + dy
          this.verifyZoomPan()
          console.log("Pan M touch orig=" + this.orig_x + ", " + this.orig_y + " video_l= " + this.video_l + " t=" + this.video_t + " delta " + dx + ", " + dy)


          if ($event.touches && $event.touches.length === 2) {
            let initialDistance = this.getDistance($event.touches[0], $event.touches[1]);
            let z = initialDistance / this.orig_distance
            let zoom = this.orig_zoom * z
            if (zoom < 1) {
              zoom = 1
            }
            this.setZoom(zoom)
            console.log("Zoom M distance " + initialDistance + " z " + z + " zoom " + zoom)
          }
        }
      }
    } else {
      if (this.bReadyToRecordTeacher) { return }

      if (this.local_drawing_poly) {
        this.local_poly_array.push($event.offsetX, $event.offsetY)
        this.local_drawing_poly.attr({ points: this.local_poly_array })
        // console.log("local mouse move " + $event.offsetX + ", " + $event.offsetY)
      }
    }
  }

  //**************************************************************************
  // Mouse Up
  //**************************************************************************
  onMouseUp = ($event: any) => {
    $event.preventDefault()
    this.orig_distance = 0
    if (this.play_video1) {
      let new_time = this.play_video1.nativeElement.currentTime
      let dif = new_time - this.last_sketch_at
      if (dif > 1) {
        this.last_sketch_at = new_time
      }

      if (this.bPanning && this.canvas) {
        if (this.pointer_id > 0) {
          this.canvas.nativeElement.releasePointerCapture(this.pointer_id)
          this.pointer_id = -1
        }

        if (this.zoom != this.orig_zoom || this.bPointPanningMouseDown || this.bTouchPanningMouseDown) {
          console.log("Zoom msg zoom=" + this.zoom + " orig_zoom= " + this.orig_zoom)
          this.orig_zoom = this.zoom
          this.setZoomPanInPlayAndSendIt()
        }
        this.bPointPanningMouseDown = false
        this.bTouchPanningMouseDown = false
        this.orig_x = 0
        this.orig_y = 0
        console.log("Pan U video_l=" + this.video_l + " t= " + this.video_t)

      } else {
        if (this.bReadyToRecordTeacher) { return }

        if (this.local_drawing_poly) {
          console.log("local mouse up")


          this.sketches.push({
            line: this.local_drawing_poly,
            time: this.last_sketch_at,
            width: this.video_cont_w,
            height: this.video_cont_h
          })
          this.updateScketches()
          let stroke = this.local_drawing_poly.node.getAttribute('stroke')
          let points = this.local_drawing_poly.node.getAttribute('points')

          let last_sketch = {
            time: new_time,
            stroke: stroke,
            array: points,
            width: this.video_cont_w,
            height: this.video_cont_h
          }

          this.training_service.setSketch(last_sketch)
          this.local_drawing_poly = undefined
        }
      }
    }
  }



  playScene(act: string, index: number) {
    this.trainingStore.dispatch(new PlayScene(act, index))
  }
  hideOverview() { //used by the phone
    if (this.isPhone) {
      setTimeout(() => {
        this.bShowOverview = false
      })
    }
  }
  //****************************************************************************
  // Caretaker proges
  //****************************************************************************

  updateProgress() {
    if (this.task_key && this.patient_id) {
      let progress = Object.assign({}, this.user_progress)
      let patients = Object.assign({}, progress.patients)
      let patient = Object.assign({}, patients[this.patient_id])
      let tasks = Object.assign({}, patient.tasks)
      let task = Object.assign({}, tasks[this.task_key])
      task.name = this.task_name
      let scenes = Object.assign([], task.scenes)
      let secne = Object.assign({}, scenes[this.scene_index])
      const formattedDate = new Date().toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      });
      if (secne[this.act] == formattedDate) {
        return
      }
      secne[this.act] = formattedDate
      scenes[this.scene_index] = secne
      task.scenes = scenes
      tasks[this.task_key] = task
      patient.tasks = tasks
      patients[this.patient_id] = patient
      progress.patients = patients
      this.trainingStore.dispatch(new UpdateProgress(progress))

      // this.training_service.recordProgress(progress)
    }
  }

  //****************************************************************************
  // UI to exit care
  //****************************************************************************

  async delTask() {
    // this.bHasMovie = false;
    this.task_name = ""
    this.task_key = ""
    this.bReadyToRecordTask = true
    this.bShowSpinner = false
    this.rec_status = 'ready'
    this.trainingStore.dispatch(new DelTask())
    // this.getMovies()
    this.goBack()
  }
  goBack() {
    // this.bHasMovie = false;
    this.task_name = ""
    this.task_key = ""

    this.bReadyToRecordTask = true
    this.rec_status = 'ready'
    this.trainingStore.dispatch(new SetTaksIndex(-1))
  }

  //****************************************************************************
  // File for task video
  //****************************************************************************
  async dropped($event: any) {
    try {
      console.log("dropped file")
      console.log("Selected to upload")
      const file = $event[0]
      let dims = await this.findFileOrStreamDim(file)
      this.setTaskVideoAndDim(dims)
      await this.sendFileToS3(file, dims.width, dims.height, dims.duration)
    } catch (e) {
      console.error(e)
    }
  }
  async uploadFile(event: Event) {
    try {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const file = input.files[0];
        let dims = await this.findFileOrStreamDim(file)
        this.setTaskVideoAndDim(dims)
        await this.sendFileToS3(file, dims.width, dims.height, dims.duration)

      }
    } catch (e) {
      console.error(e)
    }
  }
  async sendFileToS3(file: File, width: number, height: number, duration: number) {
    return new Promise<string>(async (resolve, reject) => {

      if (file) {
        let id = this.patient_id + "/" + this.task_key + "/" + file.name
        try {
          this.bShowSpinner = true
          await this.s3_service.uploadFile(file, id)
          this.task_s3_url = await this.training_service.getVideoTrainingUrl(id)
          // this.playFile(this.task_s3_url)


          this.trainingStore.dispatch(new DoneRecording(duration, true, {
            url: this.task_s3_url,
            fname: file.name,
            mime_ext: file.type,
            width: width,
            height: height
          }))
          //Now open the first

          this.training_service.stop(this.task_s3_url, true, this.duration, file.type, width, height)
          this.rec_status = "ready"
          console.log('Video uploaded successfully!');

          this.bShowSpinner = false
          resolve(this.task_s3_url)
        } catch (e) {
          console.error(e)
          this.bShowSpinner = false
          reject()
        }
      }
    })
  }

  //****************************************************************************
  // Streams
  //****************************************************************************
  async getCameraSrtreamAndDim() {
    return new Promise<any>(async (resolve, reject) => {
      function sleep(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      let ok: boolean = true
      let wd = 0
      let stream
      let dims
      do {
        stream = await this.getVideoCameraStream()
        dims = await this.findFileOrStreamDim(stream)
        ok = true
        if (!this.bTesting) {
          if (window.innerWidth > window.innerHeight && dims.width < dims.height) {
            ok = false
          } else if (window.innerWidth < window.innerHeight && dims.width > dims.height) {
            ok = false
          }
        }
        if (!ok) {
          sleep(100)
        }
      } while (!ok && ++wd < 20);


      if (ok) {
        if (wd < 20) {
          this.camera_stream = stream
          this.camera_video_width = dims.width //We will need it when we are done recording to set the dims
          this.camera_video_height = dims.height
          resolve({
            stream: stream,
            width: dims.width,
            height: dims.height
          })
        } else {
          reject("WD overflow")
        }
      } else {
        reject("no stream")
      }
    })
  }

  findFileOrStreamDim(fileOrSrc: any) {
    return new Promise<any>(async (resolve, reject) => {
      let type: string = "stream"
      const video = document.createElement("video");
      function findDim() {
        let rv: any = { width: video.videoWidth, height: video.videoHeight, duration: video.duration }

        if (fileOrSrc instanceof MediaStream) {
          rv.stream = fileOrSrc
        }
        resolve(rv)
        console.log(`#VD ${type} Width: ${video.videoWidth}, Height: ${video.videoHeight}`);
        video.removeEventListener('loadedmetadata', findDim, { capture: true });
        video.remove()
      }
      video.addEventListener('loadedmetadata', findDim);
      if (fileOrSrc instanceof MediaStream) {
        video.srcObject = fileOrSrc
      } else {
        if (fileOrSrc.url) {
          type = "s3"
          video.src = fileOrSrc.url;
          video.load()
        } else {
          try {
            type = "local"
            const videoURL = URL.createObjectURL(fileOrSrc); // Create a URL for the file
            video.src = videoURL; // Set the video src to the URL
          } catch (e) {
            reject(e)
            return
          }
        }
      }


    })
  }


  setTaskVideoAndDim(dic: any) {
    let video_parent = this.outComponent
    if (video_parent) {
      let parent_h = video_parent.nativeElement.clientHeight
      let parent_w = video_parent.nativeElement.clientWidth

      let video_w = dic.width
      let video_h = dic.height
      parent_w = 720
      if (video_w && video_h) {
        parent_h = 720 * video_h / video_w
      }
      if (parent_h > 720) {
        parent_h = 540
        if (video_w && video_h) {
          parent_w = parent_h * video_w / video_h
        }
      }

      this.video_h = parent_h
      if (video_w && video_h) {
        this.video_w = parent_h * video_w / video_h
      }
      this.video_t = 0


      this.video_cont_t = (parent_h - this.video_h) / 2
      this.video_cont_l = (720 - this.video_w) / 2

      console.log("#VP Parent " + parent_w + " " + parent_h + " video " + video_w + " " + video_h)
      console.log("#VP w " + this.video_w + " h " + this.video_h + " l " + this.video_l + " t " + this.video_t)
      let bNeedsToCheckZoom: boolean = (!this.video_cont_w && parent_w)
      this.video_cont_w = parent_w
      this.video_cont_h = parent_h
      // this.video_cont_l = this.video_l
      // this.video_cont_t = this.video_t

      this.setTaskVideoStream(dic)
      if (bNeedsToCheckZoom) {
        this.checkZoomPan(0)
      }

    }
  }
  setTaskVideoStream(dic: any) {

    let video_parent = this.outComponent
    if (video_parent && this.play_video1) {
      if (dic.stream) {
        if (dic.stream instanceof MediaStream && dic.stream.active) {
          if (!this.play_video1.nativeElement.srcObject || this.play_video1.nativeElement.srcObject.id != dic.stream.id) {
            try {
              this.play_video1.nativeElement.srcObject = dic.stream
              this.play_video1.nativeElement.play()
              this.setPlaying(true)
              if (this.remote_stream) { //If we are getting a remote stream do not use the local one
                if (this.remote_stream == dic.stream) {
                  this.play_video1.nativeElement.muted = false;
                  this.play_video1.nativeElement.volume = 1;
                }
              } else {
                this.play_video1.nativeElement.muted = true;
                this.play_video1.nativeElement.volume = 0;
              }
              this.bReadyToRecordTask = true
            } catch (error) {
              console.error("Error setting srcObject:", error);
            }
          }
          else {
            console.log("#VP same stream")
          }
        }
      } else {
        this.bReadyToRecordTask = false
        if (dic.url) {
          if (this.play_video1.nativeElement.srcObject) {
            this.play_video1.nativeElement.srcObject = undefined
          }
          this.duration = dic.duration
          this.play_video1.nativeElement.src = dic.url.url;
          this.play_video1.nativeElement.load()
          this.bShowSpinner = false
          console.log("@SV stop SrcObject1")
        } else {
          if (dic.file) {
            try {
              const videoURL = URL.createObjectURL(dic.file); // Create a URL for the file
              this.play_video1.nativeElement.src = videoURL; // Set the video src to the URL
              this.bShowSpinner = false
              console.log("@SV stop SrcObject2")
            } catch (e) {
              console.error(e)
            }
          } else {
            console.error("no dic.file")
          }
        }
        this.setCanvas(this.video_w, this.video_h)
      }
    }
  }
  setTeacherMovie(dic: any) {
    if (this.teacher_video) {
      this.bReadyToRecordTeacher = false
      if (dic.url) {
        this.duration = dic.duration
        this.teacher_video.nativeElement.src = dic.url.url;
        this.teacher_video.nativeElement.load()
        this.bShowSpinner = false
        console.log("@SV stop SrcObject1")
      } else {
        if (dic.file) {
          try {
            const videoURL = URL.createObjectURL(dic.file); // Create a URL for the file
            this.teacher_video.nativeElement.src = videoURL; // Set the video src to the URL
            this.bShowSpinner = false
            console.log("@SV stop SrcObject2")
          } catch (e) {
            console.error(e)
          }
        } else {
          console.error("no dic.file")
        }
      }
    }
  }
}
